var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F0B90B;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0c8.8,0,16,7.2,16,16s-7.2,16-16,16S0,24.8,0,16S7.2,0,16,0L16,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,16l0,4.2l3.6,2.1v2.5l-5.7-3.3v-6.7L8.8,16L8.8,16z M8.8,11.8v2.5L6.7,13v-2.5l2.1-1.2l2.1,1.2L8.8,11.8 L8.8,11.8z M13.9,10.5L16,9.3l2.1,1.2L16,11.8L13.9,10.5L13.9,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.3,19.4v-2.5l2.1,1.2v2.5L10.3,19.4L10.3,19.4z M13.9,23.2l2.1,1.2l2.1-1.2v2.5L16,26.9l-2.1-1.2V23.2 L13.9,23.2z M21.1,10.5l2.1-1.2l2.1,1.2V13l-2.1,1.2v-2.5L21.1,10.5L21.1,10.5L21.1,10.5z M23.2,20.2l0-4.2l2.1-1.2v6.7l-5.7,3.3 v-2.5L23.2,20.2L23.2,20.2L23.2,20.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.7,19.4 19.6,20.6 19.6,18.1 21.7,16.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.7,12.6l0,2.5l-3.6,2.1v4.2L16,22.7l-2.1-1.2v-4.2l-3.6-2.1v-2.5l2.1-1.2l3.6,2.1l3.6-2.1L21.7,12.6 L21.7,12.6L21.7,12.6z M10.3,8.4L16,5.1l5.7,3.4l-2.1,1.2L16,7.5l-3.6,2.1L10.3,8.4L10.3,8.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.9c2bb68f6be2e3e5b1b691dd2e0d079e.svg";
export { ForwardRef as ReactComponent };